import React from "react";
import { FiMonitor } from "react-icons/fi";
import { usePmsTheme } from "../Components/PmsThemeContext";
import { getDemoCopy } from "./demoI18n";
import "./DemoDesktopOnlyGuard.css";

export default function DemoDesktopOnlyGuard() {
  const { languageId } = usePmsTheme();
  const copy = getDemoCopy(languageId);

  return (
    <main className="demoDesktopOnlyGuard" aria-labelledby="demo-desktop-only-title">
      <div className="demoDesktopOnlyGuard__brand" aria-label="Pilcore">
        <img src={`${process.env.PUBLIC_URL}/Logo_Pilcore_Horizontal_Corporativo.svg`} alt="Pilcore" />
      </div>

      <section className="demoDesktopOnlyGuard__content">
        <div className="demoDesktopOnlyGuard__icon" aria-hidden="true">
          <FiMonitor size={29} />
        </div>
        <p className="demoDesktopOnlyGuard__eyebrow">{copy.interactive}</p>
        <h1 id="demo-desktop-only-title">{copy.desktopTitle}</h1>
        <p>{copy.desktopBody}</p>
      </section>

      <p className="demoDesktopOnlyGuard__footer">{copy.desktopFooter}</p>
    </main>
  );
}
